import { template } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
export default class RequestClinicianSearchMoreFiltersPillButton extends Component {
    @service
    clinicianSearch;
    get details() {
        return this.clinicianSearch.facetNames.pillDetails(this.args.facetName);
    }
    get chevronDirection() {
        return this.args.isOpen ? 'up' : 'down';
    }
    get chevronClass() {
        return this.args.isOpen ? 'pill-more-filters-chevron is-open' : 'pill-more-filters-chevron';
    }
    clearFilterPill = (event1)=>{
        event1?.stopPropagation?.();
        event1?.preventDefault?.();
        let qp1 = this.details.clearQueryParams;
        if (Object.keys(qp1).length) {
            this.clinicianSearch.query.applySearchFilter(qp1);
        }
    };
    static{
        template(`
    <div
      class="pill-dropdown-filter-combo
        {{if this.details.isSelected 'pill-dropdown-filter-combo-active'}}"
      data-test-clinician-search-filter-pill={{@facetName}}
    >
      <button
        type="button"
        class="filters-pill-button filters-pill-button-filter-main"
        disabled={{@isLoading}}
      >
        <span class="pill-dropdown-filter-label">{{this.details.label}}</span>
        {{#if this.details.showCount}}
          <span class="pill-filter-count">({{this.details.count}})</span>
        {{/if}}
        {{#unless this.details.isSelected}}
          <span
            class={{this.chevronClass}}
            aria-hidden="true"
            data-test-clinician-search-more-filters-chevron={{this.chevronDirection}}
          >
            {{svgJar "chevron-down"}}
          </span>
        {{/unless}}
      </button>
      {{#if this.details.isSelected}}
        <button
          type="button"
          class="filters-pill-button filters-pill-button-filter-clear"
          aria-label={{this.details.clearAriaLabel}}
          data-test-clinician-search-filter-pill-clear={{@facetName}}
          {{on "click" this.clearFilterPill}}
        >
          {{svgJar "x-circ" aria-hidden="true"}}
        </button>
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
